export default __webpack_public_path__ + "static/grandangolo-scheda-tecnica-392f85b1d4c10c746ebd0846ef4bb4db.pdf";